const steps = [
  {
    number: "01",
    icon: "ri-headphone-line",
    title: "İhtiyacınızı dinliyoruz",
    desc: "Hangi alan, ne tür bir temizlik ve hangi sıklıkta hizmet almak istediğinizi öğreniyoruz.",
  },
  {
    number: "02",
    icon: "ri-search-line",
    title: "Alan ve hizmet değerlendirmesi",
    desc: "Mekanın yapısı, kullanım yoğunluğu ve temizlik ihtiyacını detaylı şekilde değerlendiriyoruz.",
  },
  {
    number: "03",
    icon: "ri-file-list-line",
    title: "Size uygun hizmet planı",
    desc: "Değerlendirmeye göre ekipman, süreç ve takvim içeren özel bir plan hazırlıyoruz.",
  },
  {
    number: "04",
    icon: "ri-brush-line",
    title: "Profesyonel ekiple uygulama",
    desc: "Belirlenen plan doğrultusunda deneyimli ekibimizle temizlik sürecini gerçekleştiriyoruz.",
  },
  {
    number: "05",
    icon: "ri-check-double-line",
    title: "Kontrol sonrası teslim",
    desc: "Kalite kontrolü yaparak alanı size temiz, düzenli ve kullanıma hazır şekilde teslim ediyoruz.",
  },
];

export default function ProcessSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block text-xs font-medium text-accent-600 bg-accent-100/80 px-3 py-1.5 rounded-full mb-3">
            Çalışma Sürecimiz
          </span>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-3">
            Profesyonel çalışma sürecimiz
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            Her hizmetimizde aynı titizlik ve profesyonellikle ilerliyoruz. Adım adım şeffaf ve güvenilir bir süreç.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-6">
          {steps.map((step, index) => (
            <div
              key={step.number}
              className="relative bg-background-50 rounded-lg p-5 md:p-6 border border-background-200/50"
            >
              <div className="flex items-center justify-between mb-4">
                <span className="font-heading text-2xl md:text-3xl font-bold text-primary-500/30">
                  {step.number}
                </span>
                <div className="w-10 h-10 flex items-center justify-center bg-primary-50 rounded-lg">
                  <i className={`${step.icon} w-5 h-5 flex items-center justify-center text-primary-500`}></i>
                </div>
              </div>
              <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 mb-2">
                {step.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {step.desc}
              </p>
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-3 w-6 border-t-2 border-dashed border-background-300/60"></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}